import { render, staticRenderFns } from "./index_ipro.vue?vue&type=template&id=be23feb6&scoped=true"
import script from "./index_ipro.vue?vue&type=script&lang=js"
export * from "./index_ipro.vue?vue&type=script&lang=js"
import style0 from "./index_ipro.vue?vue&type=style&index=0&id=be23feb6&prod&lang=scss&scoped=true"
import style1 from "./index_ipro.vue?vue&type=style&index=1&id=be23feb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be23feb6",
  null
  
)

export default component.exports